import { motion } from "framer-motion";
import { Reveal } from "../Reveal";
import { SERVICES } from "../../data/content";

export const Services = () => {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative bg-[#f3f2ee] py-24 lg:py-36"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-16">
          <div>
            <Reveal>
              <span className="text-[#e85d04] text-xs font-bold tracking-[0.28em] uppercase">
                What We Do
              </span>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="font-display font-bold text-[#131316] text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-4">
                Full-service marine.
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.2}>
            <p className="text-[#131316]/60 max-w-sm text-lg font-light">
              One crew for anything on the water — from routine tows to
              full-scale disaster response.
            </p>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <Reveal key={s.id} delay={(i % 3) * 0.1}>
                <motion.div
                  data-testid={`service-card-${s.id}`}
                  whileHover={{ y: -8 }}
                  transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
                  className="group relative h-80 rounded-3xl overflow-hidden cursor-pointer"
                >
                  <img
                    src={s.img}
                    alt={s.title}
                    className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#09090b] via-[#09090b]/50 to-[#09090b]/10 transition-colors duration-500 group-hover:from-[#09090b] group-hover:via-[#09090b]/70" />
                  <div className="relative h-full flex flex-col justify-end p-7">
                    <div className="h-12 w-12 rounded-xl bg-[#e85d04] flex items-center justify-center mb-4 transition-transform duration-500 group-hover:-translate-y-1">
                      <Icon size={22} className="text-white" />
                    </div>
                    <h3 className="font-display font-bold text-white text-2xl leading-tight">
                      {s.title}
                    </h3>
                    <p className="text-white/0 group-hover:text-white/75 text-sm font-light mt-0 group-hover:mt-3 max-h-0 group-hover:max-h-24 overflow-hidden transition-all duration-500">
                      {s.desc}
                    </p>
                  </div>
                </motion.div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
